



















import { Prop, Vue, Component } from 'vue-property-decorator'
import { ToastType } from '@/utils/ToastAttr'

@Component
export default class DialogToast extends Vue {
    @Prop({ type: String }) type!: ToastType
    @Prop({ type: String }) title?: string
    @Prop({ type: String }) text?: string
    @Prop({ type: Object }) action?: {
        text: string
        handler: () => unknown
    }
    @Prop({ type: Function }) close!: () => unknown

    get iconClass() {
        switch (this.type) {
            case 'success':
                return 'ion-ios-checkmark-outline'
            case 'error':
                return 'ion-ios-close-outline'
            case 'warn':
                return 'ion-ios-information-outline'
            default:
                return ''
        }
    }
}
